var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-container"},[_c('p',{staticClass:"modal-message"},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn-ok",on:{"click":_vm.close}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }